const ufeApi = require('services/api/ufeApi');
const { X_REFERRAL_TTL_TOKEN } = require('components/Campaigns/Referrer/constants');

// https://confluence.sephora.com/wiki/display/ILLUMINATE/Get+Advocacy+Landing+Page+Content+API

function getAdvocacyLandingPageContent({ referrerCode, campaignCode, userId }) {
    const url = `/api/campaign/share/${referrerCode}/${campaignCode}${userId ? '?userId=' + userId : ''}`;

    return (
        ufeApi
            .makeRequest(url, {}, { returnHeaders: true })
            // Extract headers from the data, no need to pass it down
            .then(({ headers, ...data }) => {
                // Extract the token from headers and include it in the response data
                const referralToken = headers?.get(X_REFERRAL_TTL_TOKEN);

                if (referralToken) {
                    data['referralToken'] = referralToken;
                }

                return data.errorCode ? Promise.reject(data) : data;
            })
    );
}

module.exports = getAdvocacyLandingPageContent;
